import { render, staticRenderFns } from "./Terminal.vue?vue&type=template&id=f6bef7c6&"
import script from "./Terminal.vue?vue&type=script&lang=js&"
export * from "./Terminal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports